import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { TranslateModule } from "@ngx-translate/core";

import { FlexLayoutModule } from "@angular/flex-layout";
import { MatDialogModule } from "@angular/material/dialog";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatPaginatorModule } from "@angular/material/paginator";

import { ConfirmationDialogComponent } from "./confirmation-dialog/confirmation-dialog.component";
import { AlertDialogComponent } from "./alert-dialog/alert-dialog.component";
import { PasswordDialogComponent } from "./password-dialog/password-dialog.component";
import { AboutDialogComponent } from "./about-dialog/about-dialog.component";
import { DescriptionLocaleFormDialogComponent } from "./description-locale-form-dialog/description-locale-form-dialog.component";
import { ReceiptDialogComponent } from "./receipt-dialog/receipt-dialog.component";
import { EditCustomerDetailsComponent } from "./edit-customer-details-dialog/edit-customer-details-dialog.component";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatChipsModule } from "@angular/material/chips";
import { MatCardModule } from "@angular/material/card";
import { MatListModule } from "@angular/material/list";
import { MatSelectModule } from "@angular/material/select";
import { DateTimeModule } from "../date-time/date-time.module";
import { SearchCustomerDialogComponent } from './search-customer-dialog/search-customer-dialog.component';
import { CustomTableModule } from "../custom-table/custom-table.module";
import { SearchSiteDialogComponent } from './search-site-dialog/search-site-dialog.component';
import { MatTooltipModule } from "@angular/material/tooltip";
import { SearchSupplierDialogComponent } from './search-supplier-dialog/search-supplier-dialog.component';
import { ChangeMopComponent } from "./change-mop-dialog/change-mop-dialog.component";
import { ManageFilesDialogComponent } from "./manage-files-dialog/manage-files-dialog.component";
import { BarCodeGeneratorDialogComponent } from "./bar-code-generator-dialog/bar-code-generator-dialog.component";
import { SearchFilterModule } from "../search-filter/search-filter.module";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    MatDialogModule,
    MatProgressBarModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    FlexLayoutModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatCardModule,
    MatListModule,
    MatSelectModule,
    DateTimeModule,
    CustomTableModule,
    MatTooltipModule,
    SearchFilterModule,
    MatCheckboxModule,
    MatPaginatorModule
],
  exports: [
    ConfirmationDialogComponent,
    AlertDialogComponent,
    PasswordDialogComponent,
    AboutDialogComponent,
    DescriptionLocaleFormDialogComponent,
    ManageFilesDialogComponent
  ],
  declarations: [
    ConfirmationDialogComponent,
    AlertDialogComponent,
    PasswordDialogComponent,
    AboutDialogComponent,
    DescriptionLocaleFormDialogComponent,
    ReceiptDialogComponent,
    EditCustomerDetailsComponent,
    SearchCustomerDialogComponent,
    SearchSiteDialogComponent,
    SearchSupplierDialogComponent,
    ChangeMopComponent,
    ManageFilesDialogComponent,
    BarCodeGeneratorDialogComponent
  ],
})
export class DialogModule {}
